const GROWTH_UPGRADE_MEMBERSHIP = {
  EXPERIMENT_NAME: 'growth_upgrade_my_membership-1_0_0',
  CONTROL: 'control',
  VARIATION_ON: 'on',
  VARIATION_A: 'variation_a',
  VARIATION_B: 'variation_b',
  VARIATION_C: 'variation_c',
  VARIATION_CONTROL: 'control',
  FEATURE_FLAG: 'growth_upgrade_my_membership',
};

export { GROWTH_UPGRADE_MEMBERSHIP };
